<template>
    <div class="modal-overlay" ref="myBtn">
        <div class="modal">
            <h3 class="text-start w-100 m-0 cssMessage">{{message === 'Team' ? 'Teams' : message}}</h3>
            <hr class="mb-4 m-3 w-100">

            <div class="styleChoose" v-if="message === 'Users'">
                <div v-if="data.length > 0">
                    <div v-for="(d,idx) in data" :key="idx" class="d-flex gap-3 borderStyleDesign">
                        <input class="form-check-input" autocomplete="off" :id="(idx+1)" type="checkbox" :value="d.id" v-model="users" @input="removeAlert">
                        <label class="form-check-label sizeCss" :for="(idx+1)">
                            {{d.name}}
                        </label>
                    </div>
                </div>
                <div v-else>No Users</div>
            </div>

            <div class="styleChoose" v-if="message === 'Team'">
                <div v-if="data.length > 0">
                    <div v-for="(d,idx) in data" :key="idx" class="d-flex gap-3 borderStyleDesign">
                        <input class="form-check-input" autocomplete="off" :id="(idx+1)" type="checkbox" :value="d.id" v-model="teams" @input="removeAlert">
                        <label class="form-check-label sizeCss" :for="(idx+1)">
                            {{d.name}}
                        </label>
                    </div>
                </div>
                <div v-else>No Teams</div>
            </div>

            <p class="text-danger" v-if="message === 'Team'">{{errorTeam}}</p>
            <p class="text-danger" v-else>{{errorUser}}</p>
            <div class="d-flex gap-3 pt-3">
                <button class="confirm-btn" v-if="data.length > 0" @click="AssignUsers">Assign</button>
                <button class="confirm-btn" v-else style="cursor: not-allowed;pointer-events: none">Assign</button>
                <button class="cancle-btn"  @click="$emit('close-modal', state)">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
    import competition from "../../api-services/competition";
    export default {
        name: 'choose-component',
        props: ['AssignUsers', 'message', 'data' , 'training_type'],
        data() {
            return {
                state: false,
                users:[],
                teams:[],
                leaders:[],
                errorUser:'',
                errorTeam:''
            }
        },
        mounted() {
            // console.log('modal choose user '+this.training_type);
        },
        methods: {
            removeAlert(){
                this.errorUser = '';
                this.errorTeam = '';
            },
            async AssignUsers() {
                let competition_id = this.$route.params.id;

                if(this.users.length > 0){
                    try{
                        if(this.training_type !== null){
                            await competition.assignUsersTraining('users' , competition_id , {users: this.users});
                            this.errorTeam = '';
                            this.errorUser = '';
                            this.$emit('assignUsers1');
                        }else{
                            await competition.assignUsers('users' , competition_id , {users: this.users});
                            this.errorTeam = '';
                            this.errorUser = '';
                            this.$emit('assignUsers1');
                        }
                    }catch(e){
                        // console.log(e);
                    }
                }else if(this.teams.length > 0){
                    try{
                        if(this.training_type !== null){
                            await competition.assignUsersTraining('teams' , competition_id , {teams: this.teams});
                            this.errorTeam = '';
                            this.errorUser = '';
                            this.$emit('assignUsers2');
                        }else{
                            await competition.assignUsers('teams' , competition_id , {teams: this.teams});
                            this.errorTeam = '';
                            this.errorUser = '';
                            this.$emit('assignUsers2');
                        }

                    }catch(e){
                        // console.log(e);
                    }
                }else{
                    this.errorTeam = "Please Check Teams to Assign Them to Competitions or Trainings";
                    this.errorUser = "Please Check Users to Assign Them to Competitions or Trainings";
                    setTimeout(() => {
                        this.errorUser = "";
                        this.errorTeam = "";
                    },2000);
                }
            },
        }
    }
</script>

<style scoped>

    .cssMessage{
        color: var(--text-color-in-confirmation-modal);
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #E95626;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #021A24;
    }

    .sizeCss{
        font-size: 18px;
    }

    .borderStyleDesign{
        border-bottom: 1px solid #39525C;
        padding-bottom: 14px;
    }

    .form-check-input {
        border: 1px solid #e95626 !important;
        width: 24px;
        height: 22px;
        position: relative;
        left: 1px;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    .styleChoose {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        height: 294px;
        overflow-y: auto;
        justify-content: start;
    }

    .modal-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #021a24cc;
        z-index: 9999;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: start;
        align-content: center;
        align-items: center;
        position: relative !important;
        background-color: var(--background-color-input-create);
        height: 528px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
        padding: 15px;
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .confirm-btn {
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: 1px solid transparent;
    }

    .cancle-btn {
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
</style>